import { Typography, Link as MuiLink } from '@mui/material';
import { Alert } from '@client/components/globals/Modal';
import type { ErrorResponse } from '@sda/interfaces/reducer/loaders.reducer';

export const showError = (body: string | ErrorResponse): void => {
  let text = 'An unexpected error has occurred.';

  if (typeof body === 'string') {
    text = body;
  } else if (body.error) {
    text = body.error.message;
  } else if (body && body.message) {
    text = body.message;
  }

  Alert.show({
    body: (
      <>
        <Typography
          variant="body1"
          gutterBottom
        >
          {text}
        </Typography>

        <Typography
          variant="body1"
          gutterBottom
        >
          For more assistance, contact
          {' '}

          <MuiLink
            color="primary"
            id="sda-error-suppport-email-link"
            href={`mailto:${process.env.SUPPORT_EMAIL}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {process.env.SUPPORT_EMAIL}
          </MuiLink>
        </Typography>
      </>
    ),
  });
};
